import React from 'react'
import { useTranslation } from 'react-i18next'

import { CustomButton, Icon } from 'src/components/ui'
import { useActiveFilters } from 'src/zustand/stores/filters.store'

import styles from './Filters.module.scss'
import { Checkboxes, RangeSlider } from './components'

const Filters = ({ filter }: { filter: () => void }) => {
  const { t } = useTranslation()
  const isActiveFilters = useActiveFilters((state) => state.isActive)
  const toggleOpenFilters = useActiveFilters((state) => state.toggleOpenFilters)
  const quantityFilters = useActiveFilters((state) => state.quantityFilters)
  const calculationOfQuantityFilters = useActiveFilters((state) => state.calculationOfQuantityFilters)
  const resetFilters = useActiveFilters((state) => state.resetFilters)

  calculationOfQuantityFilters()

  if (isActiveFilters) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = 'auto'
  }

  const handleClickOnApply = () => {
    toggleOpenFilters()
    filter()
  }

  return (
    <div className={`${styles.filters} ${isActiveFilters && styles.active}`}>
      <div className={`${styles.filters_wrapper} ${isActiveFilters && styles.active}`}>
        <div className={styles.filters_body}>
          <div className={styles['filters_body-header']}>
            <div className={styles['filters_body-header-cancel']}>
              <button onClick={toggleOpenFilters} type='button'>
                <Icon name='back' />
              </button>
              <p>{t('bottles_page.filter')}</p>
            </div>

            <button className={styles['filters_body-header-reset']} onClick={resetFilters} type='button'>
              {t('filters.cancel')}: {quantityFilters}
            </button>
          </div>

          <div className={styles['filters_body-main']}>
            <Checkboxes
              title={t('filters.type_of_deposit')}
              arrayOfCheckboxes={[t('filters.fixed'), t('filters.any')]}
            />
            <div className={styles.line} />
            <RangeSlider />
            <div className={styles.line} />
            <Checkboxes
              title={t('filters.number_of_participants')}
              arrayOfCheckboxes={[
                t('filters.up_to_number', { number: 100 }),
                t('filters.up_to_number', { number: 200 }),
                t('filters.up_to_number', { number: 300 }),
                t('filters.up_to_number', { number: 500 }),
                t('filters.more_than_number', { number: 1000 }),
              ]}
            />
            <div className={styles.line} />
            <Checkboxes
              title={t('filters.time_of_bank')}
              arrayOfCheckboxes={[t('filters.planned'), t('filters.active')]}
            />
          </div>
        </div>

        <CustomButton variant='contained' color='violet' className={styles.filters_btn} onClick={handleClickOnApply}>
          {t('filters.apply')}
        </CustomButton>
      </div>

      <div onClick={toggleOpenFilters} className={`${styles.clickable} ${isActiveFilters ? styles.active : ''}`} />
    </div>
  )
}

export default Filters
